export default class SurveyDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2739 - Type '{ lastSync: any; }' is missing the following properties from type 'Survey': id, displayName, syncEnabled, isKeyEngagement, active
        return Object.assign(Object.assign({}, json), { lastSync: json.lastSync && new Date(json.lastSync) });
    }
}
